import axios from 'axios';
const webio = axios.create ({baseURL: 'https://webio.aparecida.go.gov.br/api/sime'});
export default webio;